<div>
  <mat-icon>info</mat-icon>
  <span>{{ 'fwSaveBar.message' | translate }}</span>
  <fw-button test-id="reset-button"
    mat-stroked-button
    variant="outline"
    (click)="reset()">
    {{ 'common.actions.discardChanges' | translate }}
  </fw-button>
  <fw-button test-id="save-button"
    mat-flat-button
    color="primary"
    (click)="save()"
    [disabled]="!saveEnabled">
    {{ 'common.actions.save' | translate }}
  </fw-button>
</div>
